import type { ReactElement } from 'react';
import { PackageContainer } from '../common/PackageContainer';
import { PackageDetails } from '../common/PackageDetails';
import { PackageList } from '../common/PackageList';
import { PackageSection } from '../common/PackageSection';
import type {
  ExperiencePackage,
  PackageSelectComponent,
  Package
} from 'packages/types';

type Props = {
  packages: ExperiencePackage[];
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

type SinglePackageProps = {
  pkg: ExperiencePackage;
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

function SinglePackage(props: SinglePackageProps) {
  return (
    <PackageContainer pkg={props.pkg} onPackageViewed={props.onPackageViewed}>
      <PackageDetails
        pkg={props.pkg}
        PackageSelectComponent={props.PackageSelectComponent}
      />
    </PackageContainer>
  );
}

export function ExperiencePackageList(props: Props): ReactElement {
  return (
    <PackageSection>
      <PackageList
        packages={props.packages}
        Package={SinglePackage}
        packageProps={{
          PackageSelectComponent: props.PackageSelectComponent,
          onPackageViewed: props.onPackageViewed
        }}
      />
    </PackageSection>
  );
}
